import { useState, useEffect } from 'react'
import { toast } from '../atomic-components/atoms/toast'
import { KycStatus } from '../utils/constants'
import { getPlayerBankAccounts } from '../utils/getPlayerBankAccounts'
import { getRegisteredBankAccounts } from '../adapters/user'
import { cookiePrefix } from '../utils/cookies'

export const useDepositPrerequisites = ({
  isOpen,
  isPage,
  onCloseDrawer,
  openCreateBankAccount,
  setSessionValue,
  translate,
  IS_PING_PIX_FLOW_ENABLED,
  openDepositFlowFromPixPing,
}) => {
  const [usableBankAccounts, setUsableBankAccounts] = useState([])
  const [depositsPrerequisitesReady, setDepositsPrerequisitesReady] =
    useState(false)
  const [hasActiveAccounts, setHasActiveAccounts] = useState(false)
  const fetchBankAccounts = async () => {
    try {
      const result = await getRegisteredBankAccounts()
      return result.data
    } catch (error) {
      toast.error(translate('common.unexpectedError'))
      return null
    }
  }

  const handleDepositPrerequisites = async () => {
    try {
      const { usableBankAccounts: bankAccountList } =
        await getPlayerBankAccounts()
      setUsableBankAccounts(bankAccountList || [])

      const pendingLivenessAccount = bankAccountList.find(
        (account) => account.status === KycStatus.WAITING_LIVENESS
      )

      if (pendingLivenessAccount) {
        setSessionValue(
          `${cookiePrefix}pendingLivenessAccount`,
          pendingLivenessAccount
        )
      }

      if ((isOpen || isPage) && !depositsPrerequisitesReady) {
        const bankAccounts = await fetchBankAccounts()
        const hasPendingAccounts =
          bankAccounts?.inactiveAccounts.filter(
            (account) => account.status === KycStatus.PENDING
          ).length > 0
        const hasActiveAccounts =
          bankAccounts?.activeAccounts?.length > 0 || hasPendingAccounts

        setHasActiveAccounts(hasActiveAccounts)

        if (typeof IS_PING_PIX_FLOW_ENABLED === 'undefined') {
          return
        }

        if (
          pendingLivenessAccount ||
          (!hasActiveAccounts && !IS_PING_PIX_FLOW_ENABLED)
        ) {
          onCloseDrawer()
          openCreateBankAccount()
        } else {
          setDepositsPrerequisitesReady(true)
        }
      }
    } catch (error) {
      toast.error(translate('common.unexpectedError'))
    }
  }

  useEffect(() => {
    if (isOpen || isPage) {
      handleDepositPrerequisites()
    }
  }, [isOpen, isPage, openDepositFlowFromPixPing, IS_PING_PIX_FLOW_ENABLED])

  return { usableBankAccounts, depositsPrerequisitesReady, hasActiveAccounts }
}